import React from 'react'
import get from 'lodash/get'
import ActualEfficiency from './actual-efficiency'
import ResourceTable from './resource-table'

export default class Content extends React.Component {
  render() {
    const overviewTab = get(this.props, 'overviewTab')
    switch (overviewTab) {
      case 1: return (
        <ActualEfficiency
          efficiencyResource={ get(this.props, 'efficiencyResource') }
        />
      )
      case 2: return (
        <ResourceTable
          searchResource={ get(this.props, 'searchResource') }
          efficiencyResource={ get(this.props, 'efficiencyResource') }
        />
      )
      default: return null
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/efficiency-resource/tab-content/lob-overview/detail/tab-content/index.js